<template>
<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.75 4.62891H16.25" stroke="#773DBD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M14.75 4.62891V15.1289C14.75 15.8789 14 16.6289 13.25 16.6289H5.75C5 16.6289 4.25 15.8789 4.25 15.1289V4.62891" stroke="#773DBD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6.5 4.62891V3.12891C6.5 2.37891 7.25 1.62891 8 1.62891H11C11.75 1.62891 12.5 2.37891 12.5 3.12891V4.62891" stroke="#773DBD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>
